<template>
  <div class="gptPrompt-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t('commonMsg.new') }}</span>
      <span v-else>{{ $t('commonMsg.edit') }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px 0 20px 20px' }"
    >
      <div class="" v-bar>
        <div class="body-wrap">
          <el-form
            label-width="120px"
            :model="form"
            @submit.native.prevent
            ref="ruleForm"
            :rules="rules"
          >
            <el-form-item label="KEY" prop="key">
              <el-input v-model="form.key" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="form.sort"
                :precision="0"
                :min="0"
                :max="999"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="业务场景" prop="scene">
              <el-select
                v-model="form.scene"
                :placeholder="$t('placeholder.select')"
                value-key="value"
                clearable
                filterable
              >
                <el-option
                  v-for="item in sceneData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场景提示语" prop="scenePrompt">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                :autosize="{ minRows: 4, maxRows: 8 }"
                v-model="form.scenePrompt"
              />
            </el-form-item>
            <el-form-item label="GPT引擎" prop="engine">
              <el-select
                v-model="form.engine"
                :placeholder="$t('placeholder.select')"
                value-key="value"
                clearable
                filterable
              >
                <el-option
                  v-for="item in engineData"
                  :key="item.engine"
                  :label="item.name"
                  :value="item.engine"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述" prop="desc">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                :autosize="{ minRows: 4, maxRows: 8 }"
                v-model="form.desc"
              />
            </el-form-item>
            <!-- <el-form-item label="语言" prop="lang">
              <el-select
                v-model="form.lang"
                :placeholder="$t('placeholder.select')"
                value-key="value"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in langData"
                  :key="index"
                  :label="item.desc"
                  :value="item.lang"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
          <div class="conditionConfigs-main">
            <div class="conditionConfigs-header">
              <p>标签配置</p>
              <button class="global-button-style" @click="addTags()">
                添加
              </button>
            </div>
            <div class="conditionConfigs-table">
              <div class="conditionConfigs-table-header">
                <div
                  v-for="(value, index) in tagsTableHeader"
                  :key="index"
                  class="conditionConfigs-table-cell conditionConfigs-table-header-cell"
                >
                  {{ value }}
                </div>
              </div>
              <div class="conditionConfigs-table-body">
                <Draggable v-model="tags" :animation="150">
                  <div
                    v-for="(item, index) in tags"
                    :key="index"
                    class="conditionConfigs-table-row"
                  >
                    <div
                      v-for="(value, key) in item"
                      :key="key"
                      class="conditionConfigs-table-cell"
                    >
                      <div v-if="key === 'sort'">{{ index + 1 }}</div>
                      <el-select
                        v-else-if="key === 'lang'"
                        v-model="item[key]"
                        :placeholder="$t('placeholder.select')"
                        value-key="value"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="(ele, idx) in langData"
                          :key="idx"
                          :label="ele.desc"
                          :value="ele.lang"
                        >
                        </el-option>
                      </el-select>
                      <el-input
                        v-else-if="key === 'name'"
                        type="textarea"
                        :rows="1"
                        placeholder="请输入内容"
                        resize="none"
                        :autosize="{ minRows: 1, maxRows: 1 }"
                        v-model="item[key]"
                      />
                      <el-switch
                        v-else-if="key === 'isShow'"
                        v-model="item[key]"
                        :active-value="true"
                        :inactive-value="false"
                      >
                      </el-switch>
                      <div v-else>{{ item[key] }}</div>
                    </div>
                    <div class="conditionConfigs-table-cell">
                      <p
                        class="delConditionConfigs-btn"
                        @click="delTags(index)"
                      >
                        删除
                      </p>
                    </div>
                  </div>
                </Draggable>
              </div>
            </div>
          </div>
          <div class="conditionConfigs-main">
            <div class="conditionConfigs-header">
              <p>条件配置</p>
              <button
                class="global-button-style"
                @click="addConditionConfigs()"
              >
                添加
              </button>
            </div>
            <div class="conditionConfigs-table">
              <div class="conditionConfigs-table-header">
                <div
                  v-for="(value, index) in conditionConfigsTableHeader"
                  :key="index"
                  class="conditionConfigs-table-cell conditionConfigs-table-header-cell"
                >
                  {{ value }}
                </div>
              </div>
              <div class="conditionConfigs-table-body">
                <Draggable v-model="conditionConfigs" :animation="150">
                  <div
                    v-for="(item, index) in conditionConfigs"
                    :key="index"
                    class="conditionConfigs-table-row"
                  >
                    <div
                      v-for="(value, key) in item"
                      :key="key"
                      class="conditionConfigs-table-cell"
                    >
                      <div v-if="key === 'sort'">{{ index + 1 }}</div>
                      <el-select
                        v-else-if="key === 'conditionIds'"
                        style="width: 100%"
                        @change="changeConditionIds(item.conditionIds, index)"
                        v-model="item.conditionIds"
                        :placeholder="$t('placeholder.select')"
                        value-key="value"
                        clearable
                        filterable
                        multiple
                      >
                        <el-option
                          v-for="item in conditionData"
                          :key="item.id"
                          :label="item.desc"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-input
                        v-else-if="key === 'prompt'"
                        type="textarea"
                        :rows="1"
                        placeholder="请输入内容"
                        resize="none"
                        :autosize="{ minRows: 1, maxRows: 1 }"
                        v-model="item.prompt"
                      />
                      <div v-else>{{ value }}</div>
                    </div>
                    <div class="conditionConfigs-table-cell">
                      <p
                        class="delConditionConfigs-btn"
                        @click="delConditionConfigs(index)"
                      >
                        删除
                      </p>
                    </div>
                  </div>
                </Draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'

export default {
  computed: {
    ...mapGetters(['buckets'])
  },
  components: {
    Draggable
  },
  data() {
    return {
      sceneData: [
        {
          label: '阅读',
          value: 'reading'
        },
        {
          label: '写作',
          value: 'writing'
        }
      ],
      engineData: [],
      langData: [],
      conditionData: [],
      form: {
        key: '',
        sort: 0,
        desc: '',
        tagConfigs: [],
        scene: '',
        scenePrompt: '',
        engine: '',
        conditionConfigs: []
      },
      tagsTableHeader: ['权重', '语言', '标签', '是否显示', '操作'],
      tags: [
        {
          sort: 0,
          lang: '',
          name: '',
          isShow: false
        }
      ],
      conditionConfigsTableHeader: ['权重', '条件', '提示语', '操作'],
      conditionConfigs: [
        {
          sort: 0, // 权重
          conditionIds: [], // 条件id
          prompt: '' // 提示语
        }
      ],
      rules: {
        key: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        desc: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        // lang: [
        //   {
        //     required: true,
        //     message: '内容不能为空',
        //     trigger: 'blur'
        //   }
        // ],
        scene: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        scenePrompt: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        engine: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    async init() {
      await this.gptGptConditionList()
      await this.getCountryList()
      await this.getGptEngineList()
      if (!this.$route.query.id) return
      this.getDetails()
    },

    async gptGptConditionList() {
      try {
        let res = await this.$http.gptGptConditionList({
          pageSize: 1000,
          page: 1
        })
        this.conditionData = res.data.rows
        return this.conditionData
      } catch (error) {}
    },

    async getCountryList() {
      try {
        let res = await this.$http.getCountryList({ pageSize: 1000, page: 1 })
        this.langData = res.data.rows
        return this.langData
      } catch (error) {}
    },
    async getGptEngineList() {
      try {
        let res = await this.$http.getGptEngineList({ pageSize: 1000, page: 1 })
        this.engineData = res.data.rows
        return this.engineData
      } catch (error) {}
    },
    async getDetails() {
      let res = await this.$http.getGptPromptDetails(this.$route.query.id)
      this.form = Object.assign(this.form, res.data)
      this.tags = this.form.tagConfigs.map((item) => {
        return {
          sort: item.sort,
          lang: item.lang,
          name: item.name,
          isShow: item.isShow
        }
      })
      this.conditionConfigs = this.form.conditionConfigs.map((item) => {
        return {
          sort: item.sort,
          conditionIds: item.conditions.map((condition) => condition.id),
          prompt: item.prompt
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && !this.hasSameConditionIds() && !this.hasEmptyTags()) {
          this.setTagsSort()
          this.setConditionConfigsSort()
          this.form.tagConfigs = this.tags
          this.form.conditionConfigs = this.conditionConfigs
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    async create() {
      await this.$http.addGptPrompt(this.form)
      this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
      this.$router.push({
        name: 'gptContent'
      })
    },

    async edit() {
      await this.$http.updateGptPrompt(this.$route.query.id, this.form)
      this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
      this.$router.push({
        name: 'gptContent'
      })
    },

    hasSameConditionIds() {
      let isDuplicated = false
      var idx = 0
      this.conditionConfigs.some((item, index) => {
        let otherItems = this.conditionConfigs.filter((_, i) => i !== index)

        isDuplicated = otherItems.some(
          (otherItem) =>
            JSON.stringify(otherItem.conditionIds.sort()) ===
            JSON.stringify(item.conditionIds.sort())
        )
        if (isDuplicated) {
          idx = index + 1
        }
        return isDuplicated
      })

      if (isDuplicated) {
        this.elMsg(`当前存在条件重复配置，请及时修改`, 'error')
      }

      return isDuplicated
    },

    setConditionConfigsSort() {
      this.conditionConfigs = this.conditionConfigs.map((item, index) => ({
        ...item,
        sort: index + 1
      }))
    },

    changeConditionIds(conditionIds, index) {
      let result = this.conditionConfigs.filter((_, i) => i !== index)
      let idx = result.findIndex(
        (item) =>
          JSON.stringify(item.conditionIds.sort()) ===
          JSON.stringify(conditionIds.sort())
      )
      if (idx !== -1) {
        this.elMsg(`当前与权重${idx + 1}条件重复，请及时修改`, 'warning')
      }
    },

    addConditionConfigs() {
      this.conditionConfigs.push({
        sort: 0,
        conditionIds: [],
        prompt: ''
      })
    },

    delConditionConfigs(index) {
      if (this.conditionConfigs.length === 1) {
        this.elMsg('至少保留一个条件配置', 'warning')
        return
      }
      this.conditionConfigs.splice(index, 1)
    },

    addTags() {
      this.tags.push({
        sort: 0,
        lang: '',
        name: '',
        isShow: false
      })
    },

    setTagsSort() {
      this.tags = this.tags.map((item, index) => ({
        ...item,
        sort: index + 1
      }))
    },

    delTags(index) {
      if (this.tags.length === 1) {
        this.elMsg('至少保留一个标签', 'warning')
        return
      }
      this.tags.splice(index, 1)
    },

    hasEmptyTags() {
      let isHasEmpty = this.tags.some((item) => {
        return !item.lang || !item.name
      })
      if (isHasEmpty) {
        this.elMsg('标签语言和名称不能为空', 'error')
      }
      return isHasEmpty
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.gptPrompt-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      padding: 0 60px;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .conditionConfigs-main {
      /* width: ; */
      margin-top: 20px;
      padding: 0 60px 0 114px;
      .conditionConfigs-header {
        display: flex;
        justify-content: space-between;
        > p {
          color: #606266;
          font-weight: 700;
        }
      }
      .conditionConfigs-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #ccc;
        margin-top: 20px;

        .conditionConfigs-table-header {
          display: flex;
          flex-direction: row;
        }
        .conditionConfigs-table-header-cell
          + .conditionConfigs-table-header-cell,
        .conditionConfigs-table-cell + .conditionConfigs-table-cell {
          border-left: 1px solid #ccc;
        }
        .conditionConfigs-table-header-cell,
        .conditionConfigs-table-cell {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2px;
          .delConditionConfigs-btn {
            color: red;
            cursor: pointer;
          }
        }

        .conditionConfigs-table-body {
          display: flex;
          flex-direction: column;
        }

        .conditionConfigs-table-row {
          display: flex;
          flex-direction: row;
          border-top: 1px solid #ccc;
        }
      }
    }
  }
}
</style>
